import {AbstractInteractionMode, DrawStyleUtil} from "./abstract-interaction-mode";
import {Feature} from "geojson";
import {v4 as uuid} from 'uuid';
import {MenuItem} from "primevue/menuitem";
import {EditorSimpleSelect} from "../interaction/editor/editor-simple-select";
import {EditorDrawPolygon} from "../interaction/editor/editor-draw-polygon";
import {MapEvent} from "../../document/model/map";
// @ts-ignore
import MapLayerSelectionDialogVue from "../../../components/map/MapLayerSelectionDialog.vue";
import {RendererUtils} from "../renderer/renderer-utils";
import store from "../../../js/store";
import {DynamicDialogCloseOptions} from "primevue/dynamicdialogoptions";

export class ClippingMode extends AbstractInteractionMode {
  static identifier: string = "clipping";
  static title: string = "Decupează";
  static icon: string = "/icons/toolbox/scissors.svg";
  //static requiresLayer: boolean = true;
  static drawStyles: any = DrawStyleUtil.drawStyle({
    "line-color": '#D20C0C',
    "line-dasharray": [0.2, 2],
    "fill-color": '#D20C0C',
    "fill-opacity": 0.3,
    "border-color": '#D20C0C',
  });

  static isShowingActionBar(): boolean {
    return true;
  }

  static interactions = {
    'select': EditorSimpleSelect.definition({selectionAllowed: true, multiSelection: true}),
    'draw_polygon': EditorDrawPolygon.definition({changeset: 'draw_polygon'})
  };

  static defaultInteraction: string = 'select';

  onInit() {
    if (this.controller.interaction.getFocused().length) {
      this.controller.interaction.setFocus([]);
    }
  }

  async onLayerGeometriesCreate(features: Feature[]) {
    features.forEach(feature => {
      feature.id = uuid()
    });
    this.controller.interaction.addTmpGeometries(features);
  }

  getGlobalActions(interactionIdentifier: string): MenuItem[] {
    return [
      {
        label: "Select",
        icon: "/icons/toolbox/editor-select.svg",
        active: interactionIdentifier === "select",
        command: () => {
          this.changeInteraction("select")
        },
        pos: { position: 'bottom' }
      },
      {
        label: "Area",
        icon: "/icons/toolbox/area.svg",
        command: () => this.changeInteraction("draw_polygon"),
        active: interactionIdentifier === "draw_polygon",
        pos: { position: 'bottom' }
      },
    ];
  }

  getActionOptions(interactionIdentifier) {
    let options: any = [];
    if (["draw_polygon", "draw_point", "draw_line"].includes(interactionIdentifier))
      options.push(
        {
          label: "Vertex list",
          icon: "/icons/toolbox/list.svg",
          command: () => {
            if (this.controller.interaction.hasManualInputDialog()) {
              this.controller.interaction.hideManualInputDialog();
            } else {
              this.controller.interaction.showManualInputDialog();
            }
            this._mapInstance.fire(MapEvent.Tick);
          },
          active: this.controller.interaction.hasManualInputDialog(),
          pos: { position: 'bottom' }
        }
      );
    return options;
  }

  getMultiActions(features, drawMode): MenuItem[] {
    //@ts-ignore

    let geometryTypes = [...new Set(features.map(feature => feature.geometry.geometry.type))];

    let actions: MenuItem[] = [];
    let sourceLayer = features[0].document;
    if (
      geometryTypes.length == 1 && (geometryTypes.includes('Polygon') || geometryTypes.includes('MultiPolygon'))
      || (geometryTypes.length == 2 && geometryTypes.includes('Polygon') && geometryTypes.includes('MultiPolygon'))
    ) {
      actions.push({
        label: 'Clip',
        icon: '/icons/toolbox/clip.svg',
        contextMenuOnly: true,
        command: () => {
          this.controller.configuration.dialogProvider().open(
            MapLayerSelectionDialogVue,
            {
              props: {
                header: this.controller.configuration.translatorProvider('Choose layer to clip'),
                style: {
                  "width": "500px",
                  "min-width": '200px',
                  "min-height": "200px",
                  "resize": "both",
                  "overflow": "hidden"
                }
              },
              data: {
                mapController: this.controller,
                layers: this.controller.getLayers().filter(x => x.documentId !== sourceLayer?.documentId),
                showMbTilesFolder: true,
                compatibilityFn: (layer: Layer) => {
                  return [
                    RendererUtils.DocumentTypes.Raster,
                    RendererUtils.DocumentTypes.MBTilesCollection,
                    RendererUtils.DocumentTypes.Georeference,
                  ].indexOf(layer.documentCategory.documentCategoryId as number) >= 0;
                }
              },
              onClose: (options: DynamicDialogCloseOptions) => {
                if (options.data?.sourceLayer === undefined) {
                  return;
                }
                this.controller.mapInstance.fire(MapEvent.ToggleLoadingSpinner, {show: true});
                let endpointData = {
                  documentId: options.data?.sourceLayer?.documentId,
                  geometries: features,
                  destinationPath: options.data?.selectedMBTilesFolder,
                  layer: options.data?.newLayer
                }


                //console.log('todo: Clipping', options.data, 'with', features);

                store.dispatch('clipByGeometries', {
                  data: endpointData,
                  headers: {
                    'x-access-token': this.controller.configuration.accessToken
                  }
                }).then(response => {
                  this.controller.configuration.toastProvider({
                    severity: "success",
                    summary: this.controller.configuration.translatorProvider("Done"),
                    detail: this.controller.configuration.translatorProvider('Successfully saved!'),
                    life: 5000,
                  });
                  if (this.controller.hasLayer(options.data?.sourceLayer)) {
                    this.controller.reloadLayer(options.data?.sourceLayer);
                    if (response) {
                      this.controller.mapInstance.fire(MapEvent.LayerAdded, {layer: response, options: {keepPosition: true}});
                      this.controller.interaction.clearFocus(true);
                      this.controller.interaction.clearTmpGeometries();
                      //this.controller.mapInstance.fire(MapEvent.Tick);
                    }
                  }
                }).catch(error => {
                  this.controller.mapInstance.fire(MapEvent.ToggleLoadingSpinner, {show: false});
                  this.controller.configuration.toastProvider({
                    severity: "error",
                    summary: "Error",
                    detail: this.controller.configuration.translatorProvider(error),
                    life: 5000,
                  });
                })

              }
            }
          )
        }
      })
    }
    return actions;

  }

}
